import { PropsWithChildren } from "react";

import { css } from "@compiled/react";

import { colors } from "@/components/product-demos/animated-jira-tour/src/helpers/colors";
import { wacToken } from "@/libraries/design/foundations";

export interface InfoComponentProps extends PropsWithChildren {
    headingText?: string;
    hideIcon?: boolean;
    text?: string;
    type?: "text" | "html" | "component";
}

const InfoSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36.01">
        <title>status-exclaim</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="N700">
                <path
                    fill="#243858"
                    d="M18,0A18.27,18.27,0,0,0,0,18.32,17.73,17.73,0,0,0,18,36,18.27,18.27,0,0,0,36,17.69,17.73,17.73,0,0,0,18,0ZM17,9A1,1,0,1,1,19,9V20.45a1,1,0,0,1-2.09,0Zm1,19a1.86,1.86,0,1,1,1.86-1.86A1.87,1.87,0,0,1,18,28Z"
                />
            </g>
        </g>
    </svg>
);

export const InfoText = (data: InfoComponentProps) => {
    const iconWrapperCss = css({
        display: "block",
        width: "30px",
        height: "30px",
        marginInlineEnd: "27.64px",
        content: "",
        backgroundPosition: "left",
        backgroundSize: "contain"
    });

    const flexContainerCss = css({
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "center",
        flexDirection: "row",
        flex: "1 1 auto"
    });

    const textContainerCss = css({
        display: "block",
        width: "100%",
        borderInlineStart: `2px solid ${colors.text}`,
        padding: "2px 0 2px 30px"
    });

    const eyebrowCss = css({
        // eslint-disable-next-line local/ensure-wac-token-usage
        color: "#42526e",
        fontSize: "1rem",
        lineHeight: "1.1em",
        fontWeight: "normal",
        textTransform: "uppercase",
        marginBlockEnd: "10px",
        fontFamily: wacToken("font.charlie.display")
    });

    const textCss = css({
        marginBlockStart: "auto",
        marginBlockEnd: "auto",
        // eslint-disable-next-line local/ensure-wac-token-usage
        color: "#091E42",
        fontSize: "1rem !important"
    });
    const linkCss = css({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        a: {
            "color": "#0052cc",
            "textDecoration": "underline",
            "cursor": "pointer",
            "&:hover": {
                // eslint-disable-next-line local/ensure-wac-token-usage
                color: "#0065ff",
                textDecoration: "none"
            }
        }
    });

    return (
        <div css={flexContainerCss}>
            <div css={iconWrapperCss}>{!data.hideIcon && <InfoSvg />}</div>
            <div css={textContainerCss}>
                <span css={eyebrowCss}>
                    {data.headingText && data.headingText}
                </span>
                {data.type === "html" ? (
                    <p
                        css={[textCss, linkCss]}
                        dangerouslySetInnerHTML={{
                            __html: data.text as string
                        }}
                    />
                ) : data.type === "component" ? (
                    <div css={textCss}>{data.children}</div>
                ) : (
                    <p css={textCss}>{data.text}</p>
                )}
            </div>
        </div>
    );
};
